<template>
  <BaseLayout>
    <div>
<!--      <h2 class="mb-4 -mt-2">Dashboard</h2>-->
      <div class="row">
        <div class="col-xl-12">
          <div class="kt-portlet">
            <div class="d-flex align-items-center px-4 py-5 border-b text-primary">
              <ServicesDropdown class="mr-3" />
              <h2>Add New Order</h2>
            </div>
            <div class="kt-portlet__body">
              <div class="kt-section">
                <div class="kt-section__content">
                  <table class="table">
                    <thead class="thead-light">
                      <tr>
                        <th>Order ID</th>
                        <th>Job Title</th>
                        <th>Service</th>
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="order in orders" :key="order.id">
                        <th>{{ order.id }}</th>
                        <td><a href="#" @click.prevent="openOrder(order.id)">{{ order.title }}</a></td>
                        <td>{{ order.service.title }}</td>
                        <td>
                          <span class="kt-badge kt-badge--inline kt-badge--pill kt-badge--bold" :class="orderStatusClass(order.status)">
                            {{ orderStatus(order.status) }}
                          </span>
                        </td>
                        <td>
                          <button type="button" class="btn btn-outline-brand btn-icon btn-sm" @click.prevent="openOrder(order.id)">
                            <i class="flaticon2-list-2"></i>
                          </button>
                          <button type="button" class="btn p-1 btn-sm ml-1" style="height: 2.5rem;"  @click.prevent="openOrder(order.id)">
                            <i class="flaticon2-chat"></i> <span class="badge badge-danger">{{order.messages_count}}</span>
                          </button>

                          <button
                            type="button"
                            class="btn p-1 btn-sm ml-1"
                            style="height: 2.5rem"
                            v-if="isDraft(order) || isPending(order)"
                            @click.prevent="editOrder(order)"
                          >
                            <i class="flaticon-edit"></i> Edit
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
<!--        <div class="col-xl-4">
          <div class="kt-portlet">
            <div class="kt-portlet__head">
              <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">Others</h3>
              </div>
            </div>
            <div class="kt-portlet__body">
              <div class="kt-section">
                <div class="kt-section__content"></div>
              </div>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import axios from 'axios';
import BaseLayout from '@/layouts/BaseLayout.vue';
import OrderStatusMixin from "@/mixins/orderStatus.js";
import EditOrderMenuMixin from "@/mixins/EditOrderMenu.js";
// import DownloadOrderResultFiles from "@/components/DownloadOrderResultFiles.vue";
import ServicesDropdown from '@/components/ServicesDropdown.vue';

export default {
  name: 'Home',
  components: {
    BaseLayout,
    // DownloadOrderResultFiles,
    ServicesDropdown,
  },
  mixins: [OrderStatusMixin, EditOrderMenuMixin],
  data() {
    return {
      orders: [],
    };
  },
  mounted() {
    axios
      .get('orders', {
        params: {
          limit: 5,
        },
      })
      .then((response) => {
        this.orders = response.data.data;
      });
  },
  methods: {
    openMessage(orderId) {
      this.$router.push({
        name: 'message',
        params: { id: orderId },
      });
    },
    openOrder(orderId) {
      this.$router.push({
        name: 'order-details',
        params: { id: orderId },
      });
    },
  },
};
</script>

<style>
  .border-b {
    border-bottom: 1px solid #ebedf2;
  }
  .-mt-2 {
    margin-top: -10px;
  }
</style>
